import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  transferSuperAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post("employee/privilege/transfer", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
